import { space } from '../../../../api/apiPaths';
import { post, get, put } from '../../../../api/commonAPI';
import * as Actions from './ListUserReviewsActionTypes';
import toastr from 'toastr';

export const updateReviewStatus = (id, status, onSuccess, onError) => {
  return dispatch => {
    dispatch({ type: Actions.UPDATE_USER_REVIEW_STATUS });
    
    put(`${space}/review/admin/status/${id}`, { status })
      .then(res => {
        dispatch({
          type: Actions.UPDATE_USER_REVIEW_STATUS_SUCCESS,
          payload: { id, status }
        });
        toastr.success(`Review successfully ${status.toLowerCase()}!`);
        if (onSuccess) onSuccess(res.data);
      })
      .catch(error => {
        dispatch({
          type: Actions.UPDATE_USER_REVIEW_STATUS_FAILS,
          payload: error
        });
        const errorMessage = error.response?.data?.errors?.[0] || 
                           error.response?.data?.message || 
                           'Failed to update user review';
        toastr.error(errorMessage);
        if (onError) onError(error);
      });
  };
};

export const fetchReviewsByStatus = (page = 1, size = 10, status = 'PENDING') => {
  return dispatch => {
    dispatch({ type: Actions.FETCH_REVIEWS });
    
    get(`${space}/review/admin/reviews?page=${page}&size=${size}&status=${status}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_REVIEWS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_REVIEWS_FAILS,
          payload: error
        });
        toastr.error('Failed to fetch reviews');
      });
  };
};
